import { Button, Card, Dialog, Inline, Stack, Text, textVariants, vars } from '@etg/wings';
import { Icon } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { ShieldCheck } from '@phosphor-icons/react';

const bulletListStyles = css`
  list-style: unset;
  padding-inline-start: 24px;
  width: 100%;

  & li {
    padding-bottom: 16px;
    :last-child {
      padding-bottom: 0;
    }
  }
`;

const cardStyles = css`
  border: 1px solid ${vars.colors.divider};
`;

const illustrationStyles = css`
  background-color: ${vars.colors.promotional.background};
  border-radius: 50%;
`;

interface ItineraryDrawerSelfTransferModalProps {
  isOpen: boolean;
  setIsOpen: (arg: boolean) => void;
}

const ItineraryDrawerSelfTransferModal = ({
  isOpen,
  setIsOpen,
}: ItineraryDrawerSelfTransferModalProps) => {
  const { t } = useTranslation();
  const listItems = [...Array(3)].map((_, index) =>
    t(`Result.Page.SelfTransferInfoModal.ListItem${index + 1}`),
  );

  return (
    <Dialog
      closeButtonAriaLabel={t('ScreenReader.CloseButtonDialog.AriaLabel.Text')}
      data-testid="itinerary-drawer-self-transfer-modal"
      illustration={
        <Icon
          className={illustrationStyles}
          color={vars.colors.promotional.foreground}
          id="self-transfer"
          size="40px"
        />
      }
      isOpen={isOpen}
      onDismiss={() => setIsOpen(false)}
      title={t('Result.Page.SelfTransferInfoModal.Title')}
    >
      <Stack spacing={24}>
        <Stack>
          <Text>{t('Result.Page.SelfTransferInfoModal.Description')}</Text>
          <ul className={bulletListStyles}>
            {listItems.map((listItem, index) => (
              <Text as="li" asHtml key={`itinerary-drawer-vi-modal-list-item-${index}`}>
                {listItem}
              </Text>
            ))}
          </ul>
          <Card className={cardStyles}>
            <Inline noWrap>
              <Inline aria-hidden>
                <ShieldCheck
                  color={vars.colors.signal.positive.foreground}
                  size="20"
                  weight="fill"
                />
              </Inline>
              <Stack spacing={4}>
                <Text variant={textVariants._16_BOLD}>
                  {t('Result.Page.SelfTransferInfoModal.Card.Title')}
                </Text>
                <Text>{t('Result.Page.SelfTransferInfoModal.Card.Description')}</Text>
                <Text asHtml>{t('Result.Page.SelfTransferInfoModal.Card.Link.Text')}</Text>
              </Stack>
            </Inline>
          </Card>
        </Stack>
        <Inline align="end">
          <Button onClick={() => setIsOpen(false)} variant="primary">
            {t('Result.Page.SelfTransferModal.Button.Text')}
          </Button>
        </Inline>
      </Stack>
    </Dialog>
  );
};

export default ItineraryDrawerSelfTransferModal;
